import React, { FC } from "react";

export const WeightDivider: FC = () => <> / </>;
